import './lib/bootstrap';
import IntersectionObserver from 'intersection-observer-polyfill';
import getBurgerAnimation from "./lib/burger-icon";
import CookiesEuBanner from 'cookies-eu-banner';
import Vue from "vue";
import UserType from "./enums/UserType";
import ContactType from "./enums/ContactType";
import {actions, getters} from "./store";
import * as VueGoogleMaps from "vue2-google-maps";
import ModalRoot from "./components/ModalRoot";
import Multiselect from "vue-multiselect";
import LoginAndSignupModal from "./components/Modals/Auth/AuthModal";
import AdsMap from "./components/AdsMap";
import InformationsModal from "./components/Modals/InformationsModal";
import ModalBus from "./eventBus";
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import Token from "./services/Token";
import Pusher from "pusher-js";
import FormationRegistrationModal from "./components/Modals/Contact/FormationRegistrationModal";
import initHome from "./home";
import VueTextareaAutosize from "vue-textarea-autosize";
import ContactForm from "./components/ContactForm";

import {VueReCaptcha} from 'vue-recaptcha-v3'
import VueRouter from "vue-router";
import Chat from "./components/Chat/Chat";
import Formations from "./components/Folders/Formations";
import FormationsSuggestions from "./components/Folders/FormationsSuggestions";
import Formation from "./components/Folders/Formation";
import SelectFolder from "./components/Folders/SelectFolder";
import MemberArea from "./components/MemberArea";
import Profile from "./components/Profile";
import CreateProfile from "./components/CreateProfile";
import Echo from "laravel-echo";
import ResetPassword from "./components/ResetPassword";
import Calendar from "./components/Calendar";
import AccommodationModal from "./components/Modals/AccommodationModal";

window.Pusher = Pusher;

Vue.use(VueReCaptcha, {
    siteKey: '6LcTIc0UAAAAAF4JGjfkgI4jzRlxAotv9I30kV0M',
    loaderOptions: {
        autoHideBadge: true
    }
});


window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '92e9624e31edcecbb544',
    cluster: 'eu',
    authEndpoint: '/api/broadcasting/auth',
    auth: {
        headers: {
            Authorization: 'Bearer ' + Token.get()
        }
    },
    encrypted: true
});

const initApp = async () => {
    /*********
     * HEADER
     *********/

    $(document).on('click', '.js-nav-toggle', () => {
        let $nav = $('.js-header-nav');

        if ($nav.hasClass('is-open')) {
            getBurgerAnimation().reverse()
        } else {
            getBurgerAnimation().play();
        }

        $nav.toggleClass('is-open');
        $nav.slideToggle();
    });

    /*********
     * COMMONS
     *********/

    const scrollTo = id => {
        let target = $('#' + id);

        if (target.length > 0) {
            let offsetTop = target.offset().top,
                width = $(window).width();

            $('.js-nav').removeClass('is-open');

            if (width > 1300) {
                offsetTop -= 110;
            } else if (width > 922) {
                offsetTop -= 150;
            } else {
                offsetTop -= 70;
            }

            $('html, body').animate({scrollTop: offsetTop}, 1000);
            window.location.hash = id;
            return true;
        }
    };

    $('[data-scroll-to]').on('click', (e) => {
        let $el = $(e.currentTarget),
            id = $el.attr('data-scroll-to');

        if (scrollTo(id)) {
            e.preventDefault();

            let $nav = $('.js-header-nav');
            if ($nav.hasClass('is-open')) {
                getBurgerAnimation().reverse();
                $nav.toggleClass('is-open');
                $nav.slideToggle();
            }

            return false;
        }
    });

    new CookiesEuBanner(function () {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m)
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

        ga('create', window.gtagId, 'auto');
        ga('send', 'pageview');
    });

    if (document.body.classList.contains('page-home')) {
        initHome();
    }

    /*********
     * REVEAL ANIMATIONS
     *********/

    const ratio = .2,
        options = {
            rootMargin: '70px 0px 0px 0px',
            threshold: ratio
        };

    const handleIntersect = function (entries, observer) {
        entries.forEach(entry => {
            if (entry.intersectionRatio > ratio) {
                entry.target.classList.add('reveal-animated');
                observer.unobserve(entry.target);
            }
        });
    };

    const observer = new IntersectionObserver(handleIntersect, options);
    document.querySelectorAll('.reveal').forEach(entry => observer.observe(entry));

    /*********
     * CATEGORIES WIDGET
     *********/

    if ($('.CategoriesWidget').length > 0) {
        $('.CategoriesWidget__item.has-children > span').on('click', function (e) {
            $(e.currentTarget)
                .parent('.CategoriesWidget__item')
                .toggleClass('is-open');
        });
    }


    window.addEventListener('load', function () {
        document.querySelector('.LoadingScreen').remove();
        if (window.location.hash) {
            setTimeout(() => scrollTo(window.location.hash.substring(1)), 500)
        }
    });
};
Vue.use(VueRouter)
Vue.prototype.$enums = {UserType, ContactType};
Vue.prototype.$campusLabel = window.campusLabel;

Vue.mixin({
    computed: {
        $user: () => getters.user()
    }
});

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDQK_lBSWTTUEN0b8p5UUueL28Y4nqAtyY',
    }
});
Vue.use(VueTextareaAutosize);
Vue.component('ModalRoot', ModalRoot);
Vue.component('Multiselect', Multiselect);
Vue.component('MemberArea', MemberArea);
Vue.component('ContactForm', ContactForm);
Vue.component('LoginAndSignupModal', LoginAndSignupModal);
Vue.component('AdsMap', AdsMap);
Vue.component('InformationsModal', InformationsModal);
Vue.component('GmapCluster', GmapCluster);
Vue.component('Calendar', Calendar);

Vue.component('chat', Chat);
Vue.component('profile', Profile);
Vue.component('create-profile', CreateProfile);
Vue.component('ResetPassword', ResetPassword);


const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (from) {
            return from
        } else {
            return {x: 0, y: 0}
        }
    },
    routes: [
        {
            path: '/espace-membres',
            component: Chat,
            name: 'chat'
        },
        {
            path: '/espace-membres/mes-formations',
            component: Formations,
            name: 'formations_root',
            children: [
                {
                    path: '',
                    name: 'formations',
                    component: FormationsSuggestions
                },
                {
                    path: ':formationId',
                    component: Formation,
                    name: 'formations_view'
                }
            ]
        },
        {
            path: '/espace-membres/mes-employes',
            name: 'folders_root',
            component: Formations,
            children: [
                {
                    path: '',
                    name: 'folders',
                    component: SelectFolder
                },
                {
                    path: ':folderId',
                    component: FormationsSuggestions,
                    name: 'folders_view'
                },
                {
                    path: ':folderId/:formationId',
                    component: Formation,
                    name: 'folders_formation'
                }
            ]
        }
    ]
})

const App = new Vue({
    el: '#app',
    router,
    methods: {
        openContactModal: () => {
            ModalBus.$emit('open', {component: LoginAndSignupModal, props: {}})
        },
        openAuthModal: () => {
            ModalBus.$emit('open', {component: LoginAndSignupModal, props: {}})
        },
        openAccommodationModal: (e) => {
            e.preventDefault();
            ModalBus.$emit('open', {component: AccommodationModal, props: {}})
        },
        openFormation(formation) {
            ModalBus.open({
                component: FormationRegistrationModal,
                props: {
                    formation
                }
            });
        }
    },
    created() {
        if (Token.has()) {
            actions.fetchUser()
        }
    },
    mounted() {
        let url = window.location.href;
        if (url.includes('/connexion')) {
            ModalBus.$emit('open', {component: LoginAndSignupModal, props: {}})
        }

        initApp();
    }
});
